'use client';

import { SITE } from '@/app/constants';
import { CommunityEnum, RecommendSubTab } from '@/app/types';
import { FeedContainer } from '../_components/FeedContainer';
import { RecommendPageClient } from '../recommend/RecommendPageClient';

export const TutorialPageClient = () => {
  if (SITE === 'china') {
    return <RecommendPageClient activeSubTab={RecommendSubTab.Tutorial} />;
  }

  return <FeedContainer exploreTab={CommunityEnum.Tutorial} />;
};
